module.exports = __webpack_public_path__ + "components/modal-app-popup/static/safari-icon-5bb592074175bf1a2847fcbf8da5efa9.webp";